// filters.ts

import Vue from "vue";

export const FILTERS: any = {
  formatMoney: (value: any) => {
    
    let languageId: number = 1;
    const sOlsUser = sessionStorage.getItem('olsUser');
    const olsUser = sOlsUser != null ? JSON.parse(sOlsUser) : null;

    if(olsUser){
      if(olsUser.userLocale != null && olsUser.userLocale != '' && olsUser.userLocale === 'fr'){
        languageId = 2
      }
    }
    
    if (!value) {
      return languageId == 2 ? '0,00$' : '$0.00';
    }

    return languageId == 2 ? parseFloat(value).toFixed(2).replace('.', ',') + '$' : '$' + parseFloat(value).toFixed(2);
  },
  toYesNo: (value: any) => {

    let languageId: number = 1;
    const sOlsUser = sessionStorage.getItem('olsUser');
    const olsUser = sOlsUser != null ? JSON.parse(sOlsUser) : null;

    if(olsUser){
      if(olsUser.userLocale != null && olsUser.userLocale != '' && olsUser.userLocale === 'fr'){
        languageId = 2
      }
    }

    // If value is boolean
    if (!value) {
      return languageId == 2 ? 'NON' : 'NO'
    }

    // Ensure value is a string before checking with `.includes()`
    const stringValue = String(value).toUpperCase(); // Normalize case for comparison

    if (stringValue === "NO") {
        return languageId === 2 ? "NON" : "NO";
    }

    if (stringValue === "YES") {
        return languageId === 2 ? "OUI" : "YES";
    }

    // If value is boolean
    return languageId == 2 ? 'OUI' : 'YES'
  },
  toKg: (value: any) => {

    let languageId: number = 1;
    const sOlsUser = sessionStorage.getItem('olsUser');
    const olsUser = sOlsUser != null ? JSON.parse(sOlsUser) : null;

    if(olsUser){
      if(olsUser.userLocale != null && olsUser.userLocale != '' && olsUser.userLocale === 'fr'){
        languageId = 2
      }
    }

    if (value == null) return '';
    if ('' + value == '') return '';

    // // Check if value is a valid decimal number
    const number = parseFloat(value);

    if (!isNaN(number)) {
      // If French (e.g., 2 = French)
      if (languageId === 2) {
        // Convert to string with comma as decimal separator
        return number.toLocaleString('fr-FR') + ' kg';
      } else {
        // Use English or default
        return number.toLocaleString('en-US') + ' kg';
      }
    }
  },
  toMeter: (value: any) => {
    let languageId: number = 1;
    const sOlsUser = sessionStorage.getItem('olsUser');
    const olsUser = sOlsUser != null ? JSON.parse(sOlsUser) : null;

    if(olsUser){
      if(olsUser.userLocale != null && olsUser.userLocale != '' && olsUser.userLocale === 'fr'){
        languageId = 2
      }
    }

    if (value == null) return '';
    if ('' + value == '') return '';

    // // Check if value is a valid decimal number
    const number = parseFloat(value);
    const isNumber = Number(value) % 1 !== 0;

    if (isNumber) {
      // If French (e.g., 2 = French)
      if (languageId === 2) {
        // Convert to string with comma as decimal separator
        return number.toLocaleString('fr-FR') + ' m';
      } else {
        // Use English or default
        return number.toLocaleString('en-US') + ' m';
      }
    }
  },
  toMeterDecimal: (value: any) => {
    let languageId: number = 1;
    const sOlsUser = sessionStorage.getItem('olsUser');
    const olsUser = sOlsUser != null ? JSON.parse(sOlsUser) : null;

    if(olsUser){
      if(olsUser.userLocale != null && olsUser.userLocale != '' && olsUser.userLocale === 'fr'){
        languageId = 2
      }
    }

    if (value == null) return '';
    if ('' + value == '') return '';

    const number = parseFloat(value);
    const isNumber = Number(value) % 1 !== 0;

    if (isNumber) {
      if (languageId === 2) {
        return number.toLocaleString('fr-FR') + ' m';
      } else {
        return number.toLocaleString('en-US') + ' m';
      }
    }else{
      if (languageId === 2) {
        return number.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m';
      } else {
        return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m';
      }
    }
  },
  checkValueItem: (vi: any) => {
    if (!vi) return;

    if (vi.isRequired && (vi.value == null || vi.value == "")) {
      vi.hasError = true;
      vi.error = vi.requiredError;
      return;
    }

    vi.hasError = false;
    vi.error = "";
  },
  dateToString: (someDate: any) => {
    if (!someDate) return "";
    if (someDate == null) return "";
    const ddd = new Date("" + someDate);
    const mm = ddd.getMonth() + 1; // getMonth() is zero-based
    const dd = ddd.getDate();
    return mm + "/" + dd + "/" + ddd.getFullYear();
  },
  dateToStringYMD: (someDate: any) => {
    if (!someDate) return "";
    if (someDate == null) return "";
    const ddd = new Date("" + someDate);
    const mm = ddd.getMonth() + 1; // getMonth() is zero-based
    const dd = ddd.getDate();
    return ddd.getFullYear() + "/" + mm + "/" + dd;
  },
  dateToStringDateWithWeekDay: (dateString: string) => {
    // Parse the input date string to a Date object
    const date = new Date(dateString);
  
    // Helper function to get the day of the week
    const getDayOfWeek = (date: Date) => {
      const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      return days[date.getUTCDay()];
    };
  
    // Helper function to get the month name
    const getMonthName = (date: Date) => {
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      return months[date.getUTCMonth()];
    };
  
    // Get day of the week
    const dayOfWeek = getDayOfWeek(date);
  
    // Get day of the month
    const dayOfMonth = date.getUTCDate();
  
    // Get month name
    const monthName = getMonthName(date);
  
    // Get year
    const year = date.getUTCFullYear();
  
    // Get hours and minutes
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
  
    // Format time
    const formatTime = (hours: number, minutes: number) => {
      const hour = hours % 12 || 12;
      const ampm = hours < 12 ? 'AM' : 'PM';
      const minute = minutes < 10 ? '0' + minutes : minutes;
      return `${hour}:${minute} ${ampm}`;
    };
  
    // Get formatted time
    const formattedTimeStart = formatTime(hours, minutes);
    const formattedTimeEnd = formatTime(hours + 1, minutes);
  
    // Construct the final formatted string
    return `${dayOfWeek}, ${dayOfMonth} ${monthName} ${year} ${formattedTimeStart} - ${formattedTimeEnd}`;
  }
}

export const registerFilters = function () {
  Object.keys(FILTERS).forEach(key => {
    Vue.filter(key, FILTERS[key]);
  })
}
